import { render, staticRenderFns } from "./BestsellersProduct.vue?vue&type=template&id=7b3ed7cd"
import script from "./BestsellersProduct.vue?vue&type=script&lang=js"
export * from "./BestsellersProduct.vue?vue&type=script&lang=js"
import style0 from "./BestsellersProduct.vue?vue&type=style&index=0&id=7b3ed7cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports